<template>
  <div id="DocumentLimitTransactionInterestRate" class="sun not-full" ref="step22">
    <!--이율-->
      <div class="mt-20px rate" v-for="(rate, index) in rates" :key="`rate-${index}`">
        <div @click="autocompleteRate(rate)" class="title">{{rate.title}}</div>
        <div class="w-100 mt-10px">
          <div class="inputbox f-l"
              :class="{'not-matched': rate.inputValue && rate.isAgreed == false }">
            <span class="label">{{ rate.isPrincipalRate ? '대출 한도 금액의' : '연' }}</span>
            <span class="unit">%</span>
            <div class="input year">
              <span :style="{'opacity': rate.isAgreed ? '0' : '100'}">
                {{ rate.value }}
              </span>
              <input type="number"
                v-model="rate.inputValue"
                :ref="`rate-${index}`"
                @input="checkRate(rate)"
                :style="{
                  'color': rate.isAgreed ? '#1baaf1': '#333333',
                  'font-weight': rate.isAgreed ? 600 : 500}"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="description2 mt-8px">
        * 대출 한도 금액이란, ‘미상환된 대출 원금 잔액’이 아닌 본 여신한도거래계약서 제1조에 기재된 ‘한도 금액’을 의미함
      </div>
      <div class="caution">
        * 현행 금융이자 보호에 관한 법률에 따른 최고이자율은 연 20%입니다.
      </div>
      <div class="caution">
        * 부채증명서 발급 요청 시 발급 비용은 10,000원 입니다.
      </div>
  </div>
</template>

<script>
export default {
  props: ['loan'],
  data() {
    return {
      // rates의 type은 offer의 필드명과 맞춤
      rateTypes: [
        {
          title: '정상이율',
          type: 'interest_rate',
        },
        {
          title: '연체이율',
          type: 'overdue_interest_rate'
        },
        {
          title: '수수료율',
          type: 'fee_rate'
        }
      ],
      rates: []
    }
  },
  created() {
    // 연이율 목록 세팅
    for (const rateType of this.rateTypes) {
      let isPrincipalRate = false
      let value = this.loan.offer[rateType.type]

      // 기존의 프리미엄 수수료 선취 방식
      if (rateType.type === 'fee_rate' && !value && this.loan.offer.period_in_days === 180) {
        value = 0.022
        isPrincipalRate = true
      }

      if (rateType.type === 'overdue_interest_rate' && value == null) {
        continue
      }

      this.rates.push({
        title: rateType.title, // 제목
        type: rateType.type,
        value: (value * 100).toFixed(1), // 연이율
        inputValue: null, // 사용자 입력값
        isAgreed: false, // 사용자 입력값이 연이율과 같은지
        clickCount: 0, // autocompleteRate()에서 사용될 클릭 횟수
        isPrincipalRate
      })
    }
    console.log(this.rates)
  },
  methods: {
    autocompleteRate(rate) {
      // 제목 5번 클릭하면 채워져야함;;;
      rate.clickCount++
      if (rate.clickCount >= 5) {
        rate.inputValue = rate.value
        this.checkRate(rate)
      }
    },
    checkRate(rate) {
      rate.isAgreed = String(rate.inputValue) === String(rate.value)
      if (rate.isAgreed) {
        const nextIndex = this.rates.findIndex(rate => rate.isAgreed === false)
        if (nextIndex && this.$refs[`rate-${nextIndex}`]) {
          this.$refs[`rate-${nextIndex}`][0].focus()
        }
      }
      this.$set(this.rates, this.rates.indexOf(rate), rate)
      this.checkAllRates()
    },
    checkAllRates() {
      if (this.rates.every(rate => rate.isAgreed === true)) {
        this.$emit('complete')
      } else {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionInterestRate {
    .d-none {
      display: none !important;
    }

    .title {
      font-weight: 600;
    }

    .caution, .description2 {
      font-size: 15px;
      line-height: 1.53;
      letter-spacing: -0.2px;
      color: #727d8c;
    }

    .textbox {
      font-size: 16px;
      line-height: 1.38;
      color: #8a94a2;
      padding: 15px 20px;
      border: solid 1px #d7e1ea;
      border-radius: 4px;
      background: white;

      &.active {
        color: #1baaf1;
        font-weight: 600;
      }
    }

    .rate {
      width: 100%;

      // .description, description2 {
      //   width: 100%;
      //   font-size: 15px;
      //   line-height: 1.53;
      //   letter-spacing: -0.2px;
      // }

      .inputbox {
        display: inline-block;
        width: 100%;
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        background-color: #ffffff;

        padding-left: 15px;
        padding-right: 15px;

        &.not-matched {
          border: solid 1px #ff1616;
        }

        .label {
          float: left;
        }
        .input {
          display: block;
          margin-right: 4px;
          text-align: left;
          line-height: 48px;
          height: 48px;
          float: right;
          span {
            display: inline-block;
            height: 100%;
            text-align: left;
            color: #8a94a2;
            font-weight: 400;
            z-index: 1;
          }
          input {
            display: inline-block;
            position: absolute;
            min-width: 200%;
            height: 100%;
            top: 0;
            left: 0;
            padding: 0;
            background: none;
            z-index: 2;
            overflow: visible;
          }
        }
        .unit {
          float: right;
        }

        div, span, input {
          display: inline-block;
        }
      }
    }

    .agree {
      width: 100%;
      font-size: 15px;
      line-height: 48px;
      font-weight: 600;

      .agreebtn, .agreebtn:hover {
        float: right;
        width: 80px;
        height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        font-size: 15px;
        line-height: 1.6;
        color: #727d8c !important;
        background-color: white !important;
        &.active, &.active:hover {
          color: #1baaf1 !important;
          background-color: white !important;
          font-weight: 600;
        }
      }
    }
  }
</style>
